import './PwaModal.sass';

import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { LottieIcon } from '$uikit';

import { ReactComponent as IcShare } from './share.svg';
import { ReactComponent as IcArrow } from './arrow.svg';
import { useTranslator } from '$hooks';
import { statReachGoal } from '$utils';

export const PwaModal: FC = () => {
  const t = useTranslator();
  const [step, setStep] = useState(window.isFromTelegramInApp ? 'fallback' : 'info');

  const isInstagram = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf('instagram') > -1;
  }, []);

  useEffect(() => {
    statReachGoal('pwa_modal_open', {
      target: isInstagram ? 'instagram' : 'other',
    });
  }, [isInstagram]);

  const handleFallback = useCallback(() => {
    setStep('fallback');
    statReachGoal('pwa_modal_fallback');
  }, []);

  function renderContent() {
    if (isInstagram) {
      return (
        <div className="PwaModal">
          <div className="PwaModal__icon">
            <LottieIcon name="phone" size={120} />
          </div>
          <div className="PwaModal__info">{t('pwa_modal_info_instagram')}</div>
        </div>
      );
    }

    if (step === 'fallback') {
      return (
        <div className="PwaModal">
          {window.isFromTelegramInApp && (
            <div className="PwaModal__icon">
              <LottieIcon name="phone" size={120} />
            </div>
          )}
          <div className="PwaModal__info">{t('pwa_modal_fallback_info')}</div>
          <div className="PwaModal__arrow_fallback">
            <IcArrow />
          </div>
        </div>
      );
    }

    return (
      <div className="PwaModal">
        <div className="PwaModal__icon">
          <LottieIcon name="phone" size={120} />
        </div>
        <div className="PwaModal__info">
          {t('pwa_modal_info_prefix')} <IcShare /> {t('pwa_modal_info')}
        </div>
        <div className="PwaModal__fallback" onClick={handleFallback}>
          {t('pwa_modal_fallback_btn')}
        </div>
        <div className="PwaModal__arrow">
          <IcArrow />
        </div>
      </div>
    );
  }

  function renderAside() {
    if (isInstagram) {
      return (
        <div className="PwaModal__arrow_insta">
          <IcArrow />
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <BottomSheet title={t('pwa_modal_title')} asideContent={renderAside()}>
      {renderContent()}
    </BottomSheet>
  );
};
